/* @ngInject */
const consultRun = (
  $transitions,
  $state,
  consultMenu,
  routes
) => {
  $transitions.onSuccess({
    to: routes.consult.index.path,
  }, (trans) => {
    const dest = routes.consult.index.path + '.' + consultMenu.radio.value
    $state.go(dest)
  })
}

export default consultRun



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/consult.run.js